/**
 * Kiểm tra field bắt buộc trước khi lưu vườn (admin + hiện trường).
 * Ném Error với danh sách thiếu — UI và api/vuon dùng chung.
 */
export function kiemTraThongTinVuon(data) {
  const thieu = [];
  const tenVuon = String(data?.tenVuon ?? "").trim();
  const so = Number(String(data?.dienTichHa ?? "").replace(",", "."));
  if (!tenVuon) thieu.push("Tên vườn");
  if (Number.isNaN(so) || so <= 0) thieu.push("Diện tích (ha)");
  if (!String(data?.tinh ?? "").trim()) thieu.push("Tỉnh/Thành phố");
  if (!String(data?.xa ?? "").trim()) thieu.push("Xã/Phường");
  if (!Array.isArray(data?.giongBo) || data.giongBo.length === 0) {
    thieu.push("Giống bơ đang trồng");
  }
  if (thieu.length > 0) {
    throw new Error(`Vui lòng nhập đủ thông tin vườn: ${thieu.join(", ")}.`);
  }
  return {
    ...data,
    tenVuon,
    dienTichHa: so,
  };
}
